export { default as DashboardPage } from "./pages/DashboardPage";
export { default as dashboardConstants } from "./constants";
export { default as dashboardReducer } from "./reducer";



// WEBPACK FOOTER //
// ./src/modules/dashboard/index.js